import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Theme from '../../theme';
import { SuccessfulIndicator } from '../../ui/components';

export class MonitorConnectionSuccessful extends React.PureComponent<any, any>  {
  public render() {
    const { liveHeartRate } = this.props;
    return (
      <View style={styles.container}>
        <View style={styles.loaderTextContainer}>
          <SuccessfulIndicator />
          <Text style={[styles.statusText, { color: Theme.GREY, paddingHorizontal: 5 }]}>Monitor connected!</Text>
        </View>
        <View style={styles.heartRateTextContainer}>
          <Text style={styles.statusText}>Heart Rate</Text>
          <Text style={styles.statusAction}>{`${liveHeartRate}bpm`}</Text>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    paddingVertical: 10,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  loaderTextContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  heartRateTextContainer: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  statusAction: {
    color: Theme.CHARCOAL,
    fontSize: 22,
    lineHeight: 24,
    fontFamily: Theme.Custom700,
  },
  statusText: {
    color: Theme.CHARCOAL,
    fontSize: 16,
    fontFamily: Theme.Custom500,
  }
});
